import useExpenses from './useExpenseCategories';

export default useExpenses;
